import { render, staticRenderFns } from "./BulkQuestionare.vue?vue&type=template&id=32ffaa55&"
import script from "./BulkQuestionare.vue?vue&type=script&lang=ts&"
export * from "./BulkQuestionare.vue?vue&type=script&lang=ts&"
import style0 from "./BulkQuestionare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports